import React from 'react';
import { Helmet } from 'react-helmet';
const { REACT_APP_SERVER_URI: serverUri } = process.env;
const Head = ({
    page,
    head: {
        title,
        meta: {
            description: metaDescription,
            title: metaTitle,
            image: metaImage
        }
    }
}) => (<Helmet>
    {!!title && <title>{title.text}</title>}
    {!!metaTitle && <meta name='title' content={metaTitle.text} />}
    {!!metaTitle && <meta name='og:title' content={metaTitle.text} />}
    {!!metaImage && <meta name='og:image' content={`${serverUri}ogImage/${page}`} />}
    {!!metaDescription && <meta name='description' content={metaDescription.text} />}
    {!!metaDescription && <meta name='og:description' content={metaDescription.text} />}
    {!!metaDescription && <meta name='twitter:description' content={metaDescription.text} />}
</Helmet>);

export default Head;